import axios from "axios";
import { API_URL } from "./constants";
import { toast } from "react-toastify";

axios.defaults.baseURL = API_URL;

export default axios;

// A refused delete can still answer 200 with { success: false, message }, so the body decides the
// outcome, not the status code. Treating those as successes ran onSuccess and toasted "deleted"
// over a record that is still there.
export const deleteData = (url, onSuccess, token) => {
  axios({
    url: url,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      // Omitted when absent so the global Authorization default applies instead of "Bearer undefined".
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  })
    .then((res) => {
      const body = res?.data;
      if (body?.success === false) {
        toast.error(body?.message || body?.errorMessage || "Error Deleting Data");
        return;
      }
      onSuccess();
      toast.success("Data Deleted Successfully");
    })
    .catch((err) => {
      const body = err?.response?.data;
      toast.error(body?.errorMessage || body?.message || "Error Deleting Data");
    });
};
